import { api } from './client';

export interface CartItemDto {
  id: number;
  itemId: number;
  qty: number;
  addedAt: string;
  item: {
    id: number;
    code: string;
    name: string;
    category: string;
    unit: string;
    hsn: string | null;
    gstPct: number;
    mrp: number;
    imageUrl: string | null;
    barcode: string | null;
  };
}

export interface CartDto {
  id: number;
  updatedAt: string;
  items: CartItemDto[];
}

export async function getCart(): Promise<CartDto> {
  const r = await api.get<CartDto>('/cart');
  return r.data;
}

export async function addCartItem(itemId: number, qty: number): Promise<CartDto> {
  const r = await api.post<CartDto>('/cart/items', { itemId, qty });
  return r.data;
}

export async function updateCartItem(itemId: number, qty: number): Promise<CartDto> {
  const r = await api.patch<CartDto>(`/cart/items/${itemId}`, { qty });
  return r.data;
}

export async function removeCartItem(itemId: number): Promise<CartDto> {
  const r = await api.delete<CartDto>(`/cart/items/${itemId}`);
  return r.data;
}

export async function clearCart(): Promise<CartDto> {
  const r = await api.delete<CartDto>('/cart');
  return r.data;
}
